module.exports = __webpack_public_path__ + "img/c_sauza.c8e9bbab.png";